import { BugTransitionGeneratedEntity } from "./generated/BugTransitionGeneratedEntity";

export abstract class BugTransitionEntity extends BugTransitionGeneratedEntity {
    // Comment to preserve new line
}
